import React from 'react';
import { Box, Typography, IconButton, Link } from '@mui/material';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useTranslation } from 'react-i18next';

const Footer4 = ({ toggleLanguage, currentLang }) => {
  const { t } = useTranslation();

  // URLs for flag icons - you can replace with your own images or emoji if you want
const flags = {
  en: `${process.env.PUBLIC_URL}/images/us.svg`,   // USA flag image path
  es: `${process.env.PUBLIC_URL}/images/spain.svg` // Spain flag image path
};


  return (
    <Box
      sx={{
        backgroundColor: 'white',
        color: '#2C3A49',
        px: 2,
        py: 2,
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        position: 'relative', // for absolute center text
        minHeight: { xs: 'auto', md: '60px' },
      }}
    >
      {/* Left: Accessibility Icon + Logo */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
     {/*    <AccessibilityNewIcon /> */}
<img
  src={`${process.env.PUBLIC_URL}/images/vz_white_bg.png`}
  alt="Vision Zero Logo"
  style={{ height: '10vh', objectFit: 'contain' }}
/>

      </Box>

      {/* Center: Copyright */}
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          position: { md: 'absolute' },
          left: { md: '50%' },
          transform: { md: 'translateX(-50%)' },
          //whiteSpace: 'nowrap',
          textAlign: 'center',
          width: { xs: '100%', md: 'auto' },
          my: { xs: 1, md: 0 },
          zIndex: 1,
        }}
      >
        {t('footer4.copyright')}
      </Typography>

      {/* Right: Instagram and Language Switch with flags */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
        <IconButton
          href="https://www.instagram.com/miamilakesvisionzero"
          target="_blank"
          rel="noopener noreferrer"
        >
          <InstagramIcon />
        </IconButton>

      </Box>
    </Box>
  );
};

export default Footer4;
